import { buildProps, numericProp, truthProp } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue'
import type { CSSProperties, PropType } from 'vue/dist/vue'
import type Tab from '../tab'

export const tabProps = buildProps({
  dot: Boolean,
  name: {
    type: numericProp,
  },
  badge: {
    type: numericProp,
  },
  title: String,
  disabled: Boolean,
  titleClass: String,
  titleStyle: {
    type: [String, Object] as PropType<string | CSSProperties>,
  },
  showZeroBadge: truthProp,
})

export type TabProps = ExtractPropTypes<typeof tabProps>
export type TabInstance = InstanceType<typeof Tab>
